import styled from 'styled-components';


export const SectionCardHeading = styled.div`
font-size: 24px;
    text-align: left;
    @media (max-width: 768px) {
      font-size: 20px;
    }`